export default __webpack_public_path__ + "static/tech-stack-header-ebfbe5105ca424f8ce43f57d7d2a7998.jpg";